import { render, staticRenderFns } from "./CategoryImageCarousel.vue?vue&type=template&id=24882f36&"
import script from "./CategoryImageCarousel.vue?vue&type=script&lang=js&"
export * from "./CategoryImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/benutzer/Desktop/401/Phywe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24882f36')) {
      api.createRecord('24882f36', component.options)
    } else {
      api.reload('24882f36', component.options)
    }
    module.hot.accept("./CategoryImageCarousel.vue?vue&type=template&id=24882f36&", function () {
      api.rerender('24882f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/phywe/CategoryImageCarousel.vue"
export default component.exports